import { render, staticRenderFns } from "./ver-modal.vue?vue&type=template&id=65b2ddd6&"
import script from "./ver-modal.vue?vue&type=script&lang=js&"
export * from "./ver-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports